import { MsgInstantiateContract } from '@goblinhunt/cosmes/client';



/**

 * Instantiates a CW2981 NFT contract using WalletConnect

 *

 * @param {WalletConnectWallet} wallet - Connected Cosmes WalletConnect wallet

 * @param {string} name - Collection name

 * @param {string} symbol - Collection symbol

 * @param {string} description - Collection description

 * @param {number} codeId - The uploaded WASM code ID

 */

export async function instantiateCWcollection(wallet, name, symbol, description, image, codeId, transactionId  ) {

  try {

    const sender = wallet.address;

    const initMsg = {
      name,
      symbol,
      creator: sender,
      minter: "terra1ldx5ysqea0ztd2cyxzzc6a778nuwjjyu6gctqx",
      collection_info_extension: {
        royalty_info: {
          address: sender,
          royalty_amount: "0.10"
        }
      }
    };

    const msg = new MsgInstantiateContract({
      sender,
      admin: sender,
      codeId,
      msg: initMsg,
      label: 'CW2981_' + name,
      funds: []
    });


    const tx = {
      msgs: [msg],
      feeDenoms: ['uluna']
    };

    const fee = await wallet.estimateFee(tx, 2.0);
    const txHash = await wallet.broadcastTx(tx, fee);

    const LCD_URL = 'https://terra-classic-lcd.publicnode.com';

    async function waitForTxResult(txHash, retries = 12, delay = 2000) {
      for (let i = 0; i < retries; i++) {
        const res = await fetch(`${LCD_URL}/cosmos/tx/v1beta1/txs/${txHash}`);
        if (res.ok) return await res.json();
        await new Promise(r => setTimeout(r, delay));
      }
      throw new Error('Transaction not found after waiting');
    }

    const data = await waitForTxResult(txHash);

    if (!data?.tx_response?.logs) {
      throw new Error('Transaction logs not found');
    }


    const logs = data.tx_response.logs;
    let contractAddress;
    
    for (const log of logs) {

      for (const event of log.events) {
        if (event.type === 'instantiate') {
          const attr = event.attributes.find(a => a.key === '_contract_address');
          if (attr) {
            contractAddress = attr.value;
            break;
          }
        }
      }
      if (contractAddress) break;
    }

    if (!contractAddress) {
      throw new Error('Contract address not found in logs');
    }

    const slug = name
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9\s-]/g, '')
      .replace(/\s+/g, '-') 
      .replace(/-+/g, '-'); 


    const saveResponse = await fetch('/save-collection', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content
      },

      body: JSON.stringify({
        contract_address: contractAddress,
        owner: wallet.address,
        name,
        slug,
        description, 
        image
      })
      
    });
    
    const result = await saveResponse.json();
    const collectionId = result.collection.id;
    
    // Update transaction log if transactionId is provided
    if (transactionId) {
      await fetch(`/transactions/${transactionId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content
        },
        body: JSON.stringify({
          hash: txHash,
          status: 'completed',
          type_id: collectionId
        })
      });
    }


    return contractAddress;

  } catch (err) {

    console.error('❌ Instantiation error:', err?.response?.data || err.message || err);

  }

}

